module.exports = __webpack_public_path__ + "img/grip-lines-vertical.032ea25d.svg";